import React from 'react';
import { connect } from 'react-redux';
import MenuTitle from 'components/MenuTitle';
import {
  pageRequest,
  setShowOutletDetailModal,
  setShowBankStatusModal,
  setOpenRegistrationOutletModal,
  setOpenTermsAndConditionsModal,
  setInformationModal,
  setShowBankAccountModalForm,
} from 'actions/setting/paymentMethod';
import { addOutletstoBankForm } from 'actions/setting/bankAccount';
import ModalAssignOutlets from 'pages/AccountSetting/BankAccount/ModalAssignOutlets/ModalAssignOutlets';
import OutletDetailModal from './OutletDetailModal';
import PaymentMethodList from './PaymentMethodList';
import RegistrationOutletModal from './RegistrationForm/RegistrationOutletModal';
import TermsAndConditionsModal from './TermsAndConditionsModal';
import InformationModal from './InformationModal';
import BankAccountModal from './RegistrationForm/BankAccountModal';
import BankStatusModal from './BankStatusModal';

class PaymentMethod extends React.Component {
  componentDidMount() {
    this.props.dispatch(pageRequest());
  }

  _onModalSubmit = (outletsValue, unlinkOutlets) => {
    this.props.dispatch(addOutletstoBankForm(outletsValue, unlinkOutlets));
  };

  render() {
    const {
      paymentMethods,
      outletStatus,
      outlets,
      menuTitle,
      isShowPaymentList,
      showModalAssignOutlets,
    } = this.props;

    if (!paymentMethods || !outletStatus || !outlets) {
      return <div />;
    }

    return (
      <div id="payment-method">
        <MenuTitle menuTitle={menuTitle} column="12" />
        {isShowPaymentList && <PaymentMethodList />}
        <OutletDetailModal
          handleClose={() => {
            this.props.dispatch(setShowOutletDetailModal(false));
          }}
        />
        <RegistrationOutletModal
          handleClose={() => {
            this.props.dispatch(setOpenRegistrationOutletModal(false));
          }}
        />
        <TermsAndConditionsModal
          handleClose={() => {
            this.props.dispatch(setOpenTermsAndConditionsModal(false));
          }}
        />
        <InformationModal
          handleClose={() => {
            this.props.dispatch(setInformationModal(false));
          }}
        />
        <BankAccountModal
          handleClose={() => {
            this.props.dispatch(setShowBankAccountModalForm(false));
          }}
        />
        <BankStatusModal
          handleClose={() => {
            this.props.dispatch(setShowBankStatusModal(false));
          }}
        />
        {showModalAssignOutlets && (
          <ModalAssignOutlets onSubmit={this._onModalSubmit} />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    paymentMethods,
    outletStatus,
    outlets,
    menuTitle,
    isShowPaymentList,
  } = state.setting.paymentMethod;
  const { showModalAssignOutlets } = state.setting.bankAccount;
  return {
    paymentMethods,
    outletStatus,
    outlets,
    menuTitle,
    isShowPaymentList,
    showModalAssignOutlets,
  };
}

export default connect(mapStateToProps)(PaymentMethod);
